import React from 'react';
import { Table as TableContainer } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';

const Table = ({ params, paramsObj, report, total, paramNames, NaNParams, unixParams, onSortChange, id, page }) => {
    const rows = report.map((row, index) => (<Row params={params} row={row} NaNParams={NaNParams} unixParams={unixParams} id={id} page={page} key={`${id}_${page}_${index}`} />));

    return (
        <TableContainer bordered style={{ borderCollapse: 'separate' }}>
            <Head onSortChange={onSortChange} params={params} paramNames={paramNames} />

            <tbody>
                {
                    total ?
                        <TotalRow params={params} paramsObj={paramsObj} data={total}/> :
                        null
                }
                {rows}
            </tbody>
        </TableContainer>
    )
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/StatsTable/components/Table/index.js